import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { Effect, Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { AppState } from '../../reducers';
import {
  ClearConditionErrors,
  ConditionActionToggleLoading,
  ConditionActionTypes,
  ConditionCreated,
  ConditionOnServerCreated,
  ConditionOnServerDeleted,
  ConditionOnServerUpdated,
  ConditionPageLoaded,
  ConditionPageRequested,
  ConditionPageToggleLoading,
  ConditionUpdated,
  ThrowConditionError,
  ConditionDeleted,
} from '../_actions/condition.actions';
import { ConditionsService } from '../_services/condition.service';

@Injectable()
export class ConditionsEffects {
  showPageLoadingDistpatcher = new ConditionPageToggleLoading({ isLoading: true });
  hideLoadingDistpatcher = new ConditionPageToggleLoading({ isLoading: false });
  showActionLoadingDistpatcher = new ConditionActionToggleLoading({ isLoading: true });
  hideActionLoadingDistpatcher = new ConditionActionToggleLoading({ isLoading: false });

  @Effect()
  loadConditionsPage$ = this.actions$.pipe(
    ofType<ConditionPageRequested>(ConditionActionTypes.ConditionPageRequested),
    mergeMap(({ payload }) => {
      this.store.dispatch(this.showPageLoadingDistpatcher);
      return this.conditionsService.findConditions(payload.entityId).pipe(
        catchError((error) => {
          return of({ error });
        }),
        map((res) => {
          if (res && res.errors) {
            this.store.dispatch(new ThrowConditionError({ error: res }));
          } else {
            this.store.dispatch(new ClearConditionErrors());
            this.store.dispatch(this.hideLoadingDistpatcher);
            const olives = [];
            this.store.dispatch(new ClearConditionErrors());
            for (let i = 0; res.entry.length > i; i++) {
              olives.push(res.entry[i].resource);
            }
            return new ConditionPageLoaded({
              conditions: olives,
              totalCount: res.total,
            });
          }
        }),
      );
    }),
  );
  @Effect()
  updateCondition$ = this.actions$.pipe(
    ofType<ConditionOnServerUpdated>(ConditionActionTypes.ConditionOnServerUpdated),
    mergeMap(({ payload }) => {
      this.store.dispatch(this.showActionLoadingDistpatcher);
      return this.conditionsService.updateCondition(payload.condition, payload.entityId).pipe(
        catchError((error) => {
          return of({ error });
        }),
        map((res: any) => {
          if (res && res.errors) {
            return new ThrowConditionError({ error: res });
          } else {
            this.store.dispatch(this.hideActionLoadingDistpatcher);
            this.store.dispatch(new ClearConditionErrors());
            return new ConditionUpdated({
              condition: {
                id: payload.condition.id,
                changes: payload.condition,
              },
            });
          }
        }),
      );
    }),
  );

  @Effect()
  createCondition$ = this.actions$.pipe(
    ofType<ConditionOnServerCreated>(ConditionActionTypes.ConditionOnServerCreated),
    mergeMap(({ payload }) => {
      this.store.dispatch(this.showActionLoadingDistpatcher);
      return this.conditionsService.createCondition(payload.condition, payload.entityId).pipe(
        catchError((error) => {
          return of(error);
        }),
        map((res) => {
          if (res && res.errors) {
            return new ThrowConditionError({ error: res });
          } else {
            this.store.dispatch(this.hideActionLoadingDistpatcher);
            this.store.dispatch(new ClearConditionErrors());
            return new ConditionCreated({ condition: payload.condition });
          }
        }),
      );
    }),
  );

  @Effect()
  deleteCondition$ = this.actions$.pipe(
    ofType<ConditionOnServerDeleted>(ConditionActionTypes.ConditionOnServerDeleted),
    mergeMap(({ payload }) => {
      this.store.dispatch(this.showActionLoadingDistpatcher);
      return this.conditionsService.deleteCondition(payload.condition_id).pipe(
        catchError((error) => {
          return of({ error });
        }),
        map(() => {
          this.store.dispatch(this.hideActionLoadingDistpatcher);
          return new ConditionDeleted({ condition_id: payload.condition_id });
        }),
      );
    }),
  );

  constructor(
    private actions$: Actions,
    private conditionsService: ConditionsService,
    private store: Store<AppState>,
  ) {}
}
